import { combineReducers, configureStore, getDefaultMiddleware } from '@reduxjs/toolkit';
import { routerMiddleware, connectRouter } from 'connected-react-router';
import { createBrowserHistory } from 'history';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage/session';
import logger from 'redux-logger';
import appReducer from './reducers/AppReducer';
import authReducer from './reducers/AuthReducer';
import TabReducer from './reducers/TabReducer';
import Appointmentsreducer from './reducers/AppoinmentReducer';
import { encryptTransform } from 'redux-persist-transform-encrypt';
import Tasksreducer from './reducers/TaskReducer';
import StateReducer from './reducers/StateReducer';

export const history = createBrowserHistory();

const secretKey = 'hgfyu765uhfhgfgb%$@TGRE^%$#fgedgf';

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ["app", "tabui","auth"],
  transforms: [
    encryptTransform({
      secretKey,
      onError: function (error) {
        // Handle the error.
      },
    }),
  ],
  
};

let isDev = process.env.NODE_ENV !== 'production'

const rootReducer = history => combineReducers({
  app: appReducer,
  auth: authReducer,
  tabui: TabReducer,
  appointments: Appointmentsreducer,
  tasks:Tasksreducer,
  stateReducer:StateReducer,
  router: connectRouter(history)
});

const persistedReducer = persistReducer(persistConfig, rootReducer(history));

// const preloadedState = {};

let middlewares = [routerMiddleware(history)]
if (isDev) middlewares.push(logger)

const store = configureStore({
  reducer: persistedReducer,
  devTools: isDev,
  middleware: getDefaultMiddleware({
    thunk: true,
    serializableCheck: false,
  }).concat(...middlewares),
  // preloadedState,
});

const persistor = persistStore(store);

export { store, persistor };
